export default __webpack_public_path__ + "static/media/attendance.5abb022f.svg";